import {
  MaterialReactTable,
  useMaterialReactTable,
} from "material-react-table";
import React from "react";
import { Box, Typography } from "@mui/material";
import { lightTable } from "../../../styles/muiProps";
import { SubTableCols } from "./cols";

export default function SubTable({ data, mainRow, key }) {
  console.log("sub Data", mainRow, data);
  const isPNID = mainRow?.materials?.[0]?.taggedMaterial?.id;

  console.log("isPNID", isPNID);
  const table = useMaterialReactTable({
    columns: SubTableCols({ isPNID }),
    data,
    ...lightTable,
  });
  return (
    <Box sx={{ width: "100%" }} onClick={(e) => e.stopPropagation()}>
      <Typography sx={{ m: 1, mt: 0 }}>History Records:</Typography>

      <MaterialReactTable table={table} />
    </Box>
  );
}
